/**
 * The compliance report kinds, as one list both apps read.
 *
 * WHY THIS IS SHARED RATHER THAN DECLARED TWICE.
 *
 * The closed set lives in four places by necessity — a Go constant, a
 * database CHECK, a Zod enum on the wire and a name for a person to read
 * — and each is a different artefact that cannot be generated from the
 * others. What is NOT necessary is declaring it twice inside the
 * frontend: the admin console's catalogue had all of it and the portal's
 * auditor seat had fifteen of twenty-five, typed `Record<string, string>`
 * so nothing complained. The seat falls back to printing the raw
 * identifier, so an external auditor — the one reader that surface
 * exists for — read `operator_access_ledger` off a screen.
 *
 * Typed by this list, a kind that is added and not named fails the build
 * in both apps.
 */
export const REPORT_KINDS = [
  "audit_log",
  "user_activity",
  "passkey_inventory",
  "policy_evaluations",
  "admin_actions",
  "compliance_posture_pdf",
  "mfa_coverage_report",
  "privileged_inactive_report",
  "automation_account_inventory",
  "access_review_packet",
  "audit_chain_integrity",
  "unused_access_report",
  "affected_principals",
  "break_glass_register",
  "auth_mandate_readiness",
  "jml_reconciliation",
  "approval_decisions",
  "session_limits_kill_time",
  "access_listing_point_in_time",
  "signed_configuration_statement",
  "dual_control_coverage",
  "operator_access_ledger",
  "portability_people",
  "portability_credentials",
  "portability_statement",
] as const;

export type ReportKind = (typeof REPORT_KINDS)[number];
